import { Group, Paper, Skeleton, Text, Tooltip } from "@mantine/core";
import { useRouteLoaderData } from "react-router-dom";
import { IconUsersGroup } from "@tabler/icons-react";
import ResellerInfo from "../../resellers/howto/ResellerInfo";
import CommunityUsersList from "./CommunityUsersList";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";

const ResellerUsers = () => {
  const lang = useLanguage((s) => s.language);
  const [tableLoading, setTableLoading] = useState(true);
  const reseller = useRouteLoaderData("reseller");
  const [profile, setProfile] = useState(null);

  return (
    <>
      <Group justify="space-between" mt={32} mb={16} gap={"xl"} align="strech">
        <Tooltip label={`Vous avez ${reseller.number_of_users} utilisateurs`}>
          <Paper p={"sm"}>
            <Group h={"100%"}>
              <IconUsersGroup color={"var(--mantine-color-primary-6)"} />
              <Text size="md" fw={600} c={"primary"}>
                {reseller.number_of_users}{" "}
                <span style={{ marginLeft: 16 }}>
                  {" "}
                  ( {reseller.number_of_users_activated}{" "}
                  {lang.white_labels.actives} )
                </span>
              </Text>
            </Group>
          </Paper>
        </Tooltip>
        <ResellerInfo
          reseller={reseller}
          tableLoading={tableLoading}
          profile={profile}
          setProfile={setProfile}
        />
      </Group>

      {profile ? (
        <CommunityUsersList
          loading={tableLoading}
          setLoading={setTableLoading}
          profile={profile}
          setProfile={setProfile}
        />
      ) : (
        <Skeleton w={"100%"} h={"calc(100vh - 300px)"} />
      )}
    </>
  );
};

export default ResellerUsers;
